shadow$provide[257] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Text:{enumerable:true, get:function() {
  return Text;
}}});
var UData = require("../../../util/data.js");
var require$three = require("three");
var require$_DOT__DOT__SLASH_data_SLASH_buffer_DOT_js = require("../data/buffer.js");
var require$_DOT__DOT__SLASH_data_SLASH_voxel_DOT_js = require("../data/voxel.js");
class Text extends require$_DOT__DOT__SLASH_data_SLASH_voxel_DOT_js.Voxel {
  static initClass() {
    this.traits = ["node", "buffer", "active", "data", "texture", "voxel", "text", "font",];
    this.defaults = {minFilter:"linear", magFilter:"linear",};
    this.finals = {channels:1};
  }
  init() {
    super.init();
    return this.atlas = null;
  }
  textShader(shader) {
    return this.atlas.shader(shader);
  }
  textIsSDF() {
    return this.props.sdf > 0;
  }
  textHeight() {
    return this.props.detail;
  }
  make() {
    let {minFilter, magFilter, type} = this.props;
    const {font, style, variant, weight, detail, sdf} = this.props;
    this.atlas = this._renderables.make("textAtlas", {font, size:detail, style, variant, weight, outline:sdf, minFilter, magFilter, type,});
    this.minFilter = require$three.NearestFilter;
    this.magFilter = require$three.NearestFilter;
    this.type = require$three.FloatType;
    require$_DOT__DOT__SLASH_data_SLASH_buffer_DOT_js.Buffer.prototype.make.call(this);
    minFilter = this.minFilter != null ? this.minFilter : this.props.minFilter;
    magFilter = this.magFilter != null ? this.magFilter : this.props.magFilter;
    type = this.type != null ? this.type : this.props.type;
    const {width} = this.props;
    const {height} = this.props;
    const {depth} = this.props;
    const reserveX = this.props.bufferWidth;
    const reserveY = this.props.bufferHeight;
    const reserveZ = this.props.bufferDepth;
    const {channels} = this.props;
    const {items} = this.props;
    let dims = this.spec = {channels, items, width, height, depth};
    this.items = dims.items;
    this.channels = dims.channels;
    const {data} = this.props;
    dims = UData.getDimensions(data, dims);
    const {space} = this;
    space.width = Math.max(reserveX, dims.width || 1);
    space.height = Math.max(reserveY, dims.height || 1);
    space.depth = Math.max(reserveZ, dims.depth || 1);
    this.buffer = this._renderables.make(this.storage, {width:space.width, height:space.height, depth:space.depth, channels:4, items, minFilter, magFilter, type,});
    const {atlas} = this;
    const {emit} = this.buffer.streamer;
    return this.buffer.streamer.emit = text => atlas.map(text, emit);
  }
  unmake() {
    super.unmake();
    if (this.atlas) {
      this.atlas.dispose();
      return this.atlas = null;
    }
  }
  update() {
    this.atlas.begin();
    super.update();
    return this.atlas.end();
  }
  change(changed, touched, init) {
    if (touched["font"]) {
      return this.rebuild();
    }
    return super.change(changed, touched, init);
  }
}
Text.initClass();

};